export default "__VITE_ASSET__a096d80c__"